import { useCallback, useEffect, useRef, useState } from "react";
import useAuthorisation from "../../utils/useAuthorization";

const DEBOUNCE_DELAY = 300;
const MIN_SEARCH_LENGTH = 3;

export const useChangeStoreModal = (fetchStores, loading) => {
  const [search, setSearch] = useState("");
  const pageRef = useRef(1);
  const debounceTimer = useRef(null);
  const inputRef = useRef(null);
  const canRead = useAuthorisation("STORE_VIEW");

  const debouncedSearch = useCallback((searchQuery) => {
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }
    pageRef.current = 1;
    if (searchQuery === "" || searchQuery.length >= MIN_SEARCH_LENGTH) {
      debounceTimer.current = setTimeout(() => {
        fetchStores(searchQuery, 1, false);
      }, DEBOUNCE_DELAY);
    }
  }, []);

  const handleStoreSearch = (e) => {
    const searchQuery = e.target.value;
    setSearch(searchQuery);
    debouncedSearch(searchQuery);
  };

  useEffect(() => {
    if (canRead) {
      fetchStores();
    }
    return () => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
    };
  }, []);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [loading]);

  return {
    search,
    setSearch,
    handleStoreSearch,
    inputRef,
  };
};
